// extracted by mini-css-extract-plugin
module.exports = {"footer500Payments":"Payments_footer-500-payments__nZu66","footer500PaymentsShowOnDesktop":"Payments_footer-500-payments--show-on-desktop__mb3s2"};